import { SVGProps } from 'react'

export const BranchingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.5 9.5C7.88071 9.5 9 8.38071 9 7C9 5.61929 7.88071 4.5 6.5 4.5C5.11929 4.5 4 5.61929 4 7C4 8.38071 5.11929 9.5 6.5 9.5ZM6.5 9.5L6.5 15.5M6.5 15.5C5.11929 15.5 4 16.6193 4 18C4 19.3807 5.11929 20.5 6.5 20.5C7.88071 20.5 9 19.3807 9 18C9 16.6193 7.88071 15.5 6.5 15.5ZM6.5 15.5C6.5 13.8431 7.84314 12.5 9.5 12.5L14.5 12.5C16.1569 12.5 17.5 11.1569 17.5 9.5M17.5 9.5C18.8807 9.5 20 8.38071 20 7C20 5.61929 18.8807 4.5 17.5 4.5C16.1193 4.5 15 5.61929 15 7C15 8.38071 16.1193 9.5 17.5 9.5Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
